// extracted by mini-css-extract-plugin
export var sectionMoreInfo = "SectionMoreInfo-module--sectionMoreInfo--j8l20";
export var socialMedia = "SectionMoreInfo-module--socialMedia--U9Aih";